/** Light / Dark / Match device. Personal to each user, by design. */
import React from 'react';
import { Sun, Moon, MonitorSmartphone } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

const OPTIONS = [
  { key: 'light', label: 'Light', icon: Sun },
  { key: 'dark', label: 'Dark', icon: Moon },
  { key: 'system', label: 'Device', icon: MonitorSmartphone },
];

export const ThemeChoice = ({ compact = false }) => {
  const { theme, choose } = useTheme();
  return (
    <div
      className={`inline-flex rounded-lg overflow-hidden ${compact ? 'border border-white/10' : 'border border-slate-300'}`}
      role="radiogroup"
      aria-label="Appearance"
      data-testid={compact ? 'theme-choice-sidebar' : 'theme-choice'}
    >
      {OPTIONS.map((o) => {
        const on = theme === o.key;
        const tone = compact
          ? (on ? 'bg-teal-500/20 text-white' : 'text-white/60 hover:text-white hover:bg-white/10')
          : (on ? 'bg-slate-900 text-white' : 'text-slate-600 hover:bg-slate-100');
        return (
          <button
            key={o.key}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => choose(o.key)}
            title={o.key === 'system' ? 'Match my device' : o.label}
            className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-semibold transition-colors ${tone}`}
            data-testid={`theme-${o.key}`}
          >
            <o.icon size={13} />
            {!compact && <span>{o.key === 'system' ? 'Device' : o.label}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default ThemeChoice;
